import { useMemo } from 'react';

//* Helpers
import { config } from '@/helpers';

//* Components
import Text from '@/components/common/Text';
import Icon from '@/components/common/Icon';
import CustomLink from '@/components/common/CustomLink';
import SortBy from '../SortBy';

//* Style
import TopBarStyle from './style';

const TopBar = ({ breadcrumbs, hasSortBy = false, className, onFilterChange }) => {
	//! Breadcrumbs
	const storeBreadcrumbs = useMemo(() => {
		return breadcrumbs?.length > 0
			? breadcrumbs.map((item, index) => {
					return (
						<div
							key={index}
							className='breadcrumb-item-wrap'>
							{item.url ? (
								<CustomLink url={item.url}>
									<Text
										className={`h3 font-futura-medium ${breadcrumbs.length - 1 !== index ? 'grey' : 'black'}`}
										text={item.name}
									/>
								</CustomLink>
							) : (
								<Text
									className={`h3 font-futura-medium ${breadcrumbs.length - 1 !== index ? 'grey' : 'black'}`}
									text={item.name}
								/>
							)}

							{breadcrumbs.length - 1 !== index ? (
								<Icon
									className={'h5 grey breadcrumb-arrow '}
									name={'arrow'}
								/>
							) : null}
						</div>
					);
			  })
			: null;
	}, [breadcrumbs]);

	return (
		<TopBarStyle className={className || ''}>
			<div className='breadcrumbs'>
				{breadcrumbs?.length > 0 ? (
					<div className='breadcrumb-item-wrap'>
						<CustomLink url={config.routes.home.path}>
							<Text
								className={`h3 font-futura-medium grey`}
								text={'home'}
							/>
						</CustomLink>

						<Icon
							className={'h5 grey breadcrumb-arrow'}
							name={'arrow'}
						/>
					</div>
				) : null}

				{storeBreadcrumbs}
			</div>

			{hasSortBy ? <SortBy onFilterChange={onFilterChange} /> : null}
		</TopBarStyle>
	);
};

export default TopBar;
